export const env = {
  apiUrl: (import.meta.env.VITE_API_URL ?? "http://localhost:8000").replace(/\/+$/, ""),
  landingUrl: (import.meta.env.VITE_LANDING_URL ?? "http://localhost:3000").replace(/\/+$/, ""),
  authMode: (import.meta.env.VITE_AUTH_MODE === "test" ? "test" : "local") as "local" | "test",
  testRole: import.meta.env.VITE_TEST_ROLE ?? "superadmin",
} as const;
